<template>
  <div>
    <div class="modal-card delivery-items">
       <header class="modal-card-head">
          <h3 class="modal-card-title is-size-3 has-text-black-bis
          is-capitalized has-text-weight-bold">
            {{cardHeader}}
           </h3>
          <div class="is-divider-vertical"></div>
          <i class="icon-close is-clickable" @click="$emit('close')"></i>
      </header>
      <section class="modal-card-body is-marginless is-visible">
        <div class="columns">
          <div class="column">
            <h3 v-if="!isUnscheduled" class=" has-text-black-bis has-text-weight-bold is-italic">
              Delivery: <span class="has-text-black-bis has-text-weight-normal">{{deliveryName}}</span>
            </h3>
            <h3 v-if="isUnscheduled" class="has-text-black-bis my-4">
              These items are not scheduled for Delivery.
            </h3>
          </div>
        </div>
        <div class="columns">
          <div class="column">
             <h3 class="is-align-items-center is-flex">
              <span class="has-text-weight-bold has-text-black-bis is-italic">Delivery Status: </span><span  class="has-text-black-bis is-pulled-left has-text-weight-normal"> <field-stage
              :isEditing="true"
              :isStatus="true"
              :shipType="rowData.shipType"
              :value="rowData.status"
              :shippingItems="rowData.items"
            ></field-stage></span>
            </h3> 
          </div>
          <div class="column">
            <div class="columns">
              <div class="column is-align-items-center is-flex">
                <span class="is-size-3 mr-1 has-text-weight-semibold has-text-black-bis is-pulled-left">Ship By:</span>
                <span>
                  <field-date
                    :isEdit="true"
                    :item="card.delivery"
                    :inputProps="{kind: 'deliveryStart', max: 'deliverBy'}"
                    @set-date="setDate"
                    :isEmptyShip="false"
                    >
                  </field-date>
                </span>                
              </div>
              <div class="column is-align-items-center is-flex">
                  <span class="is-size-3 mr-1 has-text-weight-semibold has-text-black-bis is-pulled-left">Deliver By:</span>
                <span> 
                  <field-date
                    :isEdit="true"
                    :item="card.delivery"
                    :inputProps="{min: 'deliveryStart', kind: 'deliverBy'}"
                    @set-date="setDate"
                    :isEmptyShip="false"
                    >
                  </field-date>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="columns">
            <div class="column is-3 pl-0" v-if="!isUnscheduled
              && (!['in-storage', 'in-transit', 'zombie', 'released-to-inventory', 'fulfilled'].includes(rowData.status))">
              <mf-multi-select
                v-model="selectedAction"
                track-by="event"
                label="name"
                placeholder="Add Items"
                :multiple="false"
                :options="options"
                :allow-empty="false"
                @select="fireEvent($event, true)"
                :selectedWorkstep="selectedWorkstep"
                :noDirtyEmit='true'
              ></mf-multi-select>
            </div>
            <div class="is-divider-vertical mx-0" v-if="rowData.status === 'not-started'"></div>
            <div class="column pr-0">
              <search-bar
                placeholder="Search"
                :shouldEmit="shouldEmit"
                @search="getSearchValue"
              ></search-bar>
            </div>
          </div>
        </div>
       
          <div class="my-2">
            <mf-table
              :tableProps="tableProps"
              :apiMode="false"
              :loadData="loadData"
              :hideGutter="true"
              ref="itemsTable"
              :checkedRows="checkedRow"
              @checkbox-toggled="getSelectedRow"
            >
              <template v-slot:qty-needed="{ rowData : item }">
                <qty-input
                  v-model.number="item.selectedQty"
                  :value="item.quantity"
                  :roundTo="4" :max="maxQtyAllowed(item)"
                  :isDisabled="$store.state.activeScreen === 'shipping-order-view'"
                >
                </qty-input>
              </template>
              <template v-slot:actualy-qty="{ rowData : item }">
                <qty-input
                  v-model.number="item.selectedQty"
                  :value="item?.underDeliver ? (item.actualQty - item.underDeliver) : (item.actualQty === item.quantity ? item.actualQty : item.quantity)"
                  :roundTo="4" :max="maxQtyAllowed(item)"
                  :isDisabled="true"
                >
                </qty-input>
              </template>
               <template #shipped-qty="{rowData: item}">
                <div class="has-text-right">
                  {{item.quantity}}
                </div>
              </template>
              <template #received-qty="{rowData: item}">
                <div class="has-text-right">
                  {{rowData.status === 'in-transit' ? 0 : (item.quantity - item.underDeliver)}}
                </div>
              </template>
              <template #short-qty="{rowData: item}">
                <div class="has-text-right">
                  {{rowData.status === 'in-transit' ? 0 : (item.underDeliver || 0)}}
                </div>
              </template>
              <template #issue-type="{rowData: item}">
                <div>
                  {{$_.startCase(item.issueNote)}}
                </div>
              </template>
            </mf-table>
          </div>
        </section>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <div>
          <button
            class="button is-outlined"
            @click="cancel()"
            v-if="showButton('cancel')"
          >
            Cancel
          </button>
          <button
            class="button has-background-black-bis"
            @click="updateItems(false)"
            :disabled="isDisabled"
            v-if="showButton('done')"
          >
            Done
          </button>
          <button
            class="button has-background-black-bis"
            @click="updateItems"
            :disabled="isDisabled"
            v-if="showButton('update')"
          >
            Update
          </button>
          <button
            class="button has-background-black-bis"
            @click="createDelivery"
            v-if="showButton('createDelivery')"
            >
            Schedule a New Delivery
          </button>
          <button
            class="button has-background-black-bis"
            @click="cancel()"
            v-if="isUnscheduled"
          >
            Done
          </button>
        </div>
      </footer>
     </div>
    <o-loading
      :full-page="true"
      :active="isLoading"
      :can-cancel="true"
    ></o-loading>
  </div>
</template>

<script>
import {
  computed,
  defineComponent, onMounted, reactive, toRefs, ref,
  inject,
} from 'vue';
// import Catalogs from '@/models/Catalogs';
import moment from 'moment';
import { ModalProgrammatic } from '@oruga-ui/oruga-next';
import { filter, set, cloneDeep } from 'lodash';
import { v4 as uuid } from 'uuid';
import { useToast } from 'vue-toastification';
// import Validation from '@/utils/Validations';
import deliveryItemsViewCols from '@/components/table-cols/deliveryItemsViewCols';
import unscheduledItemsViewCols from '@/components/table-cols/unscheduledItemsViewCols';
import SearchBar from '@/components/SearchBar.vue';
import QtyInput from '@/components/fields/QtyInput.vue';
import MfTable from '@/components/table-fields/MfTable.vue';
import Shipping from '@/models/Shipping';
import GeneralShippingMixin from '@/components/mixins/GeneralShippingMixin';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import MfToolbar from '@/components/table-fields/MfToolbar.vue';
import AddItemsToShipping from '@/components/modals/AddItemsToShipping.vue'; 

export default defineComponent({
  name: 'DeliveryItems',
  props: [
    'value',
    'rowField',
    'rowData',
    'isUnscheduledRow',
    'refreshCard',
    'masterCard'
  ],
  components: {
    MfTable,
    QtyInput,
    'search-bar': SearchBar,
    MfToolbar,
  },
  setup(props, { emit }) {
    const toast = useToast();
    const emitter = inject('emitter');
    const route = useRoute();
    const store = useStore();
    const router = useRouter();
    const { fetchUnscheduledRow } = GeneralShippingMixin();
    const { activeScreen } = store.state;
    const state = reactive({
      shouldEmit: true,
      deliveryName: '',
      searchText: '',
      selectedItems: [],
      partialShipment: {},
      checkedRow: [],
      isLoading: false,
      card: props.rowData,
      isUnscheduled: props.isUnscheduledRow,
      isShortReceive: false,
      unscheduledItems: [],
      mS: {},
      options: [
        {
          name: 'From Production',
          event: 'addItemsFromProd',
          label: 'From Production',
        },
        {
          name: 'From Inventory',
          event: 'addItemsFromInv',
          label: 'From Inventory',
        }
      ],
      isDateEdited: false,
    });
    const tableProps = state.isUnscheduled ? unscheduledItemsViewCols : deliveryItemsViewCols;
    if (!state.isUnscheduled) {
      if (['in-storage', 'fulfilled', 'zombie', 'released-to-inventory','in-transit','not-started'].includes(props.rowData.status)) {
        tableProps.isCheckable = false;
        tableProps.fields = tableProps.cols.delivered;
        if (!['not-started'].includes(props.rowData.status)) {
          tableProps.fields = tableProps.cols.qtyShort;
        }
      } else if (props.rowData.status === 'underDelivered') {
        tableProps.isCheckable = false;
        tableProps.fields = cloneDeep(tableProps.cols.underDelivered);
      } else {
        tableProps.fields = tableProps.cols.nonDelivered;
      }
    }
    if (activeScreen === 'shipping-order-view') tableProps.isCheckable = false;
    const itemsTable = ref(null);

    if (props.rowData.shipType === 's' && props.rowData.status === 'in-storage') {
      const isUnderDelivered = props.rowData.items.filter((item) => item.underDeliver && item.underDeliver > 0);
      if (isUnderDelivered.length) {
        state.isShortReceive = true;
      }
    }

    const cancel = (doRefresh = false) => {
      emit('close', { doRefresh });
    };

    const getSelectedRow = (row) => {
      state.selectedItems = row;
    };
    const cardHeader = computed(() => {
      if (state.isUnscheduled) {
        return 'Unscheduled Items';
      }
      return "Delivery's Items";
    });
    const isDisabled = computed(() => {
      if (state.selectedItems.length > 0 || state.isDateEdited) {
        return false;
      }
      return true;
    });

    const fetchMasterShipment = async () => {
      const shippingLabelId = route.params.cardId;
      const masterShipment = await Shipping.getPartialShipments({
        shippingLabelId,
      });
      state.mS = masterShipment;
    };

    const fetchUnscheduledItems = async () => {
      // if !isUnscheduledRow then fetch unscheduled rowData
      const rowDetails = await fetchUnscheduledRow(state.mS, []);
      const unscheduledItems = rowDetails.items;
      return unscheduledItems;
    };

    const loadData = () => {
      state.isLoading = true;
      let fetchedData = props.rowData.items;
      state.deliveryName = props.rowData.name;

      // set a unique id for each item
      fetchedData.forEach((item) => {
        set(item, 'uid', uuid());
      });

      // search
      if (fetchedData.length > 0 && state.searchText) {
        fetchedData = filter(fetchedData,
          (item) => item.name.toLowerCase().includes(state.searchText.toLowerCase()));
      }

      // by default select all
      state.checkedRow = fetchedData;
      state.selectedItems = fetchedData;
      state.isLoading = false;
      return filter(fetchedData, (item) => item.quantity || item.qtyShortLoad);
    };

    const maxQtyAllowed = (item) => {
      // max qty allowed for an item depends on the unscheduled item qty
      if (!state.isUnscheduled && state.unscheduledItems && state.unscheduledItems.length) {
        // find if item exists in unscheduled
        const unscheduledItem = state.unscheduledItems.filter((uItm) => {
          if ((uItm.id === item.id) && (uItm.catId === item.catId)) {
            return uItm;
          }
        });
        let maxQty = item.quantity;
        if (unscheduledItem.length) {
          maxQty = item.quantity + unscheduledItem[0].quantity;
          return maxQty;
        }
        return maxQty;
      }
      return item.quantity;
    };

    // get search value
    const getSearchValue = (searchText) => {
      state.searchText = searchText;
      itemsTable.value.refreshTable();
    };

    const updateItems = async (val = true) => {
      if (!val) {
        cancel();
        return;
      }
      const removeFrom = state.card.shipType === 's-m' ? 'fromSelf' : 'fromPartial';
      state.isLoading = true;
      const selectedItemsMap = {};
      for (const selectedItem of state.selectedItems) {
        const key = selectedItem.catId !== '' ? `${selectedItem.catId}:${selectedItem._id}` : selectedItem._id;
        selectedItemsMap[key] = selectedItem;
      }
      for (const item of props.rowData.items) {
        const key = item.catId !== '' ? `${item.catId}:${item._id}` : item._id;
        const selectedItem = selectedItemsMap[key];
        if (selectedItem && selectedItem.quantity > selectedItem.selectedQty) {
          state.card.removeItem(item, removeFrom, selectedItem.selectedQty);
        } else if (selectedItem && selectedItem.quantity < selectedItem.selectedQty) {
          const qtyToRemove = selectedItem.selectedQty - selectedItem.quantity;
          state.card.addItemFromShipment(selectedItem, state.mS, qtyToRemove);
        } else if (!selectedItem) {
          state.card.removeItem(item, removeFrom, 0);
        }
      }
      await state.card.save();
      state.isLoading = false;
      toast.success('Items updated successfully');
      emit('close', { doRefresh: true });
      /* new shipping Id generated if item removed.
      If shipType is 's-m', the parentShipmentId is generated in the save function of shippingLabel.js by setting it in localStorage, and the code below will execute.
      */
      const parentShipmentId = localStorage.getItem('parentShipment');
      if(removeFrom === 'fromSelf' && parentShipmentId) {
        router.replace({
                  name: 'shipping-card-edit',
                  params: {
                    cardId: parentShipmentId,
                    projectId: state.card.project._id,
                  },
        });
      }
    };
    const showButton = (type) => {
      if (activeScreen !== 'shipping-order-view') {
        if (['in-storage', 'underDelivered', 'fulfilled', 'zombie', 'released-to-inventory','in-transit'].includes(props.rowData.status) && ['done'].includes(type)) {
          return true;
        }
        if (['not-started', 'un-scheduled'].includes(props.rowData.status)
            && ['cancel', 'update'].includes(type)) {
          return true;
        }
        if (props.rowData.status === 'unscheduled' && ['cancel', 'createDelivery'].includes(type)) {
          return true;
        }
        if (props.rowData.status === 'underDeliver' && ['done'].includes(type)) {
          return true;
        }
      } else if (['done'].includes(type)) {
        return true;
      }
      return false;
    };
    const createDelivery = async () => {
      state.isLoading = true;
      await fetchMasterShipment();
      // trigger create del modal
      const emitObj = {
        card: props.rowData,
        masterShipment: state.mS,
        isActive: true,
        doRefresh: true
      };
      state.isLoading = false;
      emit('close');
      emitter.emit('toggle:createDelModal', emitObj);
    };

    const fireEvent = async (params) => {
      ModalProgrammatic.open({
        component: AddItemsToShipping,
        props: {
          card: state.card,
          isInventory: params.event === "addItemsFromInv",
          isDeliveryTab: true,
          rowData: state.mS,
          masterCard: props.masterCard,
          },
        rootClass: 'modal-sm',
        trapFocus: true,
        canCancel: false,
        events: {
          close: async () => {
            await props.refreshCard({id: state.card._id});
          }
        }
      })
    }

    const setDate = (val) => {
      if (val.kind._value === 'deliveryStart') set(state.card, 'delivery.deliveryStart', val.val);
      else if (val.kind._value === 'deliverBy') set(state.card, 'delivery.deliverBy', val.val);
      state.isDateEdited = true;
    }

    onMounted(async () => {
      await fetchMasterShipment();
      if (!state.isUnscheduled) {
        state.unscheduledItems = await fetchUnscheduledItems();
      }
      loadData();
    });

    return {
      ...toRefs(state),
      tableProps,
      loadData,
      isDisabled,
      itemsTable,
      getSearchValue,
      cancel,
      updateItems,
      maxQtyAllowed,
      getSelectedRow,
      createDelivery,
      showButton,
      cardHeader,
      fireEvent,
      setDate,
    };
  },
});
</script>
